import { useEffect, useState } from "react";
import { api } from "./apiClient";
import { SITUACOES_FALLBACK } from "../enums/enums";

// Situações do Chamado vindas da tabela chamado_situacao (GET /situacao/cons), no lugar da lista
// fixa que existia em enums.js até 2026-09-18. Motivo: quando o Lizard for desligado e a situação
// "Baixado" sair do cadastro, ela precisa sumir do Portal e do Raptor sozinha, sem deploy.
//
// A lista quase não muda, e várias telas precisam dela ao mesmo tempo (Consulta, Detalhe, Grid,
// chat), então a promessa da requisição fica memoizada no módulo: a primeira tela que montar busca,
// as outras aproveitam. Se a requisição falhar (rede, sessão, grant ausente no banco), cai no
// fallback e a tela continua de pé — nunca fica sem rótulo.
let promessaEmCurso = null;
let cache = null;

export const carregarSituacoes = () => {
  if (cache) return Promise.resolve(cache);
  if (promessaEmCurso) return promessaEmCurso;

  promessaEmCurso = api
    .get("/situacao/cons")
    .then((resp) => {
      const itens = Array.isArray(resp?.data) ? resp.data : [];
      cache = itens.length > 0 ? itens : SITUACOES_FALLBACK;
      return cache;
    })
    .catch(() => {
      // Não guarda em `cache` de propósito: foi falha, não resposta. A próxima tela tenta de novo.
      promessaEmCurso = null;
      return SITUACOES_FALLBACK;
    });

  return promessaEmCurso;
};

// Hook para quem precisa renderizar a lista (filtro, timeline). Começa com o fallback para a tela
// nascer pintada, e troca pela lista real assim que ela chega.
export const useSituacoes = () => {
  const [situacoes, setSituacoes] = useState(cache || SITUACOES_FALLBACK);

  useEffect(() => {
    let ativo = true;
    carregarSituacoes().then((itens) => {
      if (ativo) setSituacoes(itens);
    });
    return () => {
      ativo = false;
    };
  }, []);

  return situacoes;
};

// --- helpers de tradução id <-> descrição -------------------------------------------------------
// Substituem o convertToArray/mapToIds que liam os objetos de enum. Os filtros salvam a seleção do
// usuário no localStorage por DESCRIÇÃO (é o que a tela mostra), então a conversão para id passa a
// ser feita contra a lista carregada do banco.

export const descricoesDeSituacoes = (situacoes) =>
  (situacoes || []).map((s) => s.descricao);

export const idsPorDescricoes = (situacoes, descricoes) =>
  (descricoes || [])
    .map((desc) => (situacoes || []).find((s) => s.descricao === desc)?.id)
    .filter((id) => id !== undefined && id !== null);

// Rótulo de uma situação pelo id. Nunca devolve vazio: id fora da lista (situação removida do
// cadastro depois que o chamado foi gravado) aparece como "Situação <id>", visível e feio de
// propósito — mesma regra do back (functions/situacoes.ts).
export const descricaoDaSituacao = (situacoes, situacaoId) => {
  if (!situacaoId) return "";
  const achada = (situacoes || []).find((s) => s.id === situacaoId);
  return achada?.descricao || `Situação ${situacaoId}`;
};
